import React from 'react';
import { BookOpenIcon, GuitarIcon, CheckIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
const theory = ['Chord construction and 7th-chord families', 'Scales, modes, and where each one fits', 'ii-V-I harmony and common substitutions', 'Song form and how to analyze a standard'];
const practice = ['50 ready-to-play jazz exercises', 'Comping drills and rhythm patterns', 'Lines, licks, and phrasing studies', 'Step-by-step practice routines by level'];
export function TheoryPractice() {
  return <section aria-labelledby="theory-practice-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-367" data-mp="2hd4fp1dyrejf">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-368" data-mp="2ckbaydihw67c">
        <div className="mx-auto max-w-3xl text-center" data-id="element-369" data-mp="28ksqtjyhzz5k">
          <Eyebrow align="center" data-id="element-370" data-mp="28i6ktor99rpg">What you get</Eyebrow>
          <h2 id="theory-practice-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-371" data-mp="352f7htdc5ylf">
            Theory <span className="text-amber" data-id="element-372" data-mp="e57n27hlizxo">+</span> practice,{' '}
            <span className="text-amber" data-id="element-373" data-mp="e5psnuq5eqi9">in one pack</span>
          </h2>
          <p className="mt-5 font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-374" data-mp="j395qrb40x8m">
            You don&rsquo;t just get worksheets. You get the theory to explain every concept and 50
            ready-made jazz exercises to put it straight into your students&rsquo; hands.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:mt-12 lg:grid-cols-2 lg:gap-6" data-id="element-375" data-mp="3rj2qjich4uvh">
          <div className="rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-8" data-id="element-376" data-mp="ecd0rvd2csi">
            <div className="flex items-center gap-4" data-id="element-377" data-mp="3hm6c6vzw9ej0">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-wine" data-id="element-378" data-mp="3hnr74mq4ezhe">
                <BookOpenIcon className="h-6 w-6 text-cream" aria-hidden="true" data-id="element-379" data-mp="3ml9foc087cov" />
              </span>
              <div data-id="element-380" data-mp="1fsgsg2ngtce4">
                <p className="text-[11px] font-semibold uppercase tracking-label text-wine-light" data-id="element-381" data-mp="1ktnzu0lp49k9">
                  Part one
                </p>
                <h3 className="font-display text-3xl leading-none text-cream" data-id="element-382" data-mp="1jda8la9ar6hb">Theory</h3>
              </div>
            </div>
            <ul className="mt-7 space-y-4" data-id="element-383" data-mp="1ec30fa38s5a4">
              {theory.map(item => <li key={item} className="flex items-start gap-3" data-id="element-384" data-mp="19etdc13bs5pg">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-wine-light" aria-hidden="true" data-id="element-385" data-mp="15dhm5r4szcf5" />
                  <span className="text-sm leading-relaxed text-cream-soft sm:text-base" data-id="element-386" data-mp="2238h1rh0b1lh">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-8" data-id="element-387" data-mp="1sd5o1r9vxnn5">
            <div className="flex items-center gap-4" data-id="element-388" data-mp="1sasz2u5pmd0l">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-ember" data-id="element-389" data-mp="1oasjh66vjvry">
                <GuitarIcon className="h-6 w-6 text-cream" aria-hidden="true" data-id="element-390" data-mp="2ku9l2twzhnbw" />
              </span>
              <div data-id="element-391" data-mp="2g1yex9bnh5aw">
                <p className="text-[11px] font-semibold uppercase tracking-label text-ember-light" data-id="element-392" data-mp="2g0n973yn9nh5">
                  Part two
                </p>
                <h3 className="font-display text-3xl leading-none text-cream" data-id="element-393" data-mp="7iosj69ed4cu">Practice</h3>
              </div>
            </div>
            <ul className="mt-7 space-y-4" data-id="element-394" data-mp="bk0kvjjno3oq">
              {practice.map((item, index) => <li key={item} className="flex items-start gap-3" data-id="element-395" data-mp="gko8rwcl84eq" data-mpi={index}>
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber" aria-hidden="true" data-id="element-396" data-mp="ljhnfs3m21gh" />
                  <span className={`text-sm leading-relaxed sm:text-base ${index === 0 ? 'font-semibold text-amber-light' : 'text-cream-soft'}`} data-id="element-397" data-mp="qhsu5tylzvuh">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}